import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const IntegrationTestCard = () => {
  const [testResults, setTestResults] = useState(null);
  const [isTesting, setIsTesting] = useState(false);

  const handleRunTests = () => {
    setIsTesting(true);
    setTimeout(() => {
      setTestResults({
        embedCode: { status: 'success', message: 'Embed code is valid' },
        cssIsolation: { status: 'success', message: 'No style conflicts detected' },
        responsiveness: { status: 'success', message: 'Responsive on all devices' },
        performance: { status: 'warning', message: 'Consider enabling CDN' },
        security: { status: 'success', message: 'SSL and CORS configured' }
      });
      setIsTesting(false);
    }, 2000);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'success':
        return { name: 'CheckCircle2', color: 'var(--color-success)' };
      case 'warning':
        return { name: 'AlertTriangle', color: 'var(--color-warning)' };
      case 'error':
        return { name: 'XCircle', color: 'var(--color-error)' };
      default:
        return { name: 'Circle', color: 'var(--color-muted-foreground)' };
    }
  };

  const getStatusBg = (status) => {
    switch (status) {
      case 'success':
        return 'bg-success/10';
      case 'warning':
        return 'bg-warning/10';
      case 'error':
        return 'bg-error/10';
      default:
        return 'bg-muted';
    }
  };

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6 space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Integration Testing
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            Verify your embed configuration before deployment
          </p>
        </div>
        <Button
          variant="default"
          size="default"
          iconName="Play"
          iconPosition="left"
          loading={isTesting}
          onClick={handleRunTests}
          className="sm:flex-shrink-0"
        >
          Run Tests
        </Button>
      </div>
      {testResults && (
        <div className="space-y-3">
          {Object.entries(testResults)?.map(([key, result]) => {
            const statusIcon = getStatusIcon(result?.status);
            return (
              <div
                key={key}
                className={`p-4 rounded-md ${getStatusBg(result?.status)}`}
              >
                <div className="flex items-start gap-3">
                  <Icon 
                    name={statusIcon?.name} 
                    size={20} 
                    color={statusIcon?.color} 
                  />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground capitalize">
                      {key?.replace(/([A-Z])/g, ' $1')?.trim()}
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {result?.message}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {!testResults && (
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="TestTube2" size={32} color="var(--color-muted-foreground)" />
          </div>
          <p className="text-sm text-muted-foreground">
            Click "Run Tests" to verify your embed configuration
          </p>
        </div>
      )}
      <div className="pt-4 border-t border-border">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="text-center p-3 bg-muted rounded-md">
            <p className="text-2xl font-heading font-semibold text-foreground">
              98%
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Performance Score
            </p>
          </div>
          <div className="text-center p-3 bg-muted rounded-md">
            <p className="text-2xl font-heading font-semibold text-foreground">
              0.8s
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Average Load Time
            </p>
          </div>
          <div className="text-center p-3 bg-muted rounded-md">
            <p className="text-2xl font-heading font-semibold text-foreground">
              100%
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Mobile Compatible
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationTestCard;